import ColumnStockItem from "./ColumnStockItem";

export default ColumnStockItem;